export default [
  {
    title: 'Support',
    icon: 'life-ring',
    resource: 'Support',
    children: [
      {
        title: 'Dashboard',
        route: 'Tickets dashboard',
        resource: 'TicketsDashboard',
        action: 'manage',
      },
      {
        title: 'Support',
        route: 'Tickets',
        resource: 'Tickets',
      },
    ]
  },
]
